module.exports = __webpack_public_path__ + "docs/img/getstarted_bg.fa30efe6.png";